const CNPJ = ({ value, warn, empty }) => {
  const cnpj = (value || "").replace(/[^\d]/g, "");

  if (cnpj.length === 0) return empty || "";

  if (cnpj.length !== 14) return warn ? "Inválido" : cnpj;

  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
};

export default CNPJ;
